(function () {
  const ALLOWED_HOSTS = [
    "summit.pointclickcare.com",
    "summitpccdev.wpengine.com",
    "summitpccstage.wpengine.com",
  ];

  // Bail early if we're not on an allowed domain
  if (ALLOWED_HOSTS.indexOf(window.location.hostname) === -1) {
    return;
  }

  const UTM_KEYS = ["utm_medium", "utm_source", "utm_campaign"];
  const COOKIE_DAYS = 30;

  // --- Cookie helpers ---
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      ";expires=" +
      date.toUTCString() +
      ";path=/;SameSite=Lax";
  }

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  }

  // --- Step 1: Capture UTMs from URL and store in cookies ---
  function captureUTMs() {
    const params = new URLSearchParams(window.location.search);
    UTM_KEYS.forEach(function (key) {
      const value = params.get(key);
      if (value) {
        setCookie(key, value, COOKIE_DAYS);
      }
    });
  }

  // --- Step 2: Append cookied UTMs to /registration links ---
  function appendUTMsToRegistrationLinks() {
    const utms = {};
    UTM_KEYS.forEach(function (key) {
      const val = getCookie(key);
      if (val) utms[key] = val;
    });

    if (Object.keys(utms).length === 0) return;

    document.querySelectorAll("a[href*='/registration']").forEach(function (a) {
      const href = a.getAttribute("href");
      if (!href) return;

      try {
        const url = new URL(href, window.location.origin);

        Object.keys(utms).forEach(function (key) {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, utms[key]);
          }
        });

        if (href.startsWith("http")) {
          a.setAttribute("href", url.toString());
        } else {
          a.setAttribute("href", url.pathname + url.search + url.hash);
        }
      } catch (err) {
        // Ignore malformed URLs (mailto:, tel:, javascript:, etc.)
      }
    });
  }

  captureUTMs();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", appendUTMsToRegistrationLinks);
  } else {
    appendUTMsToRegistrationLinks();
  }
})();